import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { useTheme } from '@mui/material/styles';
import { CONSTANTS } from '../../../../constants/constants';
import NRKeyValueDataDisplay from '../../../NRKeyValueDataDisplay/NRKeyValueDataDisplay';
import {
  SSVCExploitationFormatter,
  SSVCAutomatableFormatter,
  SSVCTechImpactFormatter
} from '../../VulnerabilitiesTableCustomComponents/NRSSVCProviders';

const { SSVC_SECTION } = CONSTANTS.TABLE.VULNERABILITIES_TABLE.VULNERABILITY_DETAIL_DRAWER;
const { TITLE, TOOLTIP_BOLD, TOOLTIP, EXPLOITATION, TECHNICAL_IMPACT, AUTOMATABLE, SOURCE } = SSVC_SECTION;

const KEY_WIDTH = '30%';

const NRSsvcDetails = ({ cveDetails }) => {
  const theme = useTheme();
  const ssvc = cveDetails?.ssvc;

  if (!ssvc) return null;

  const tooltipContent = (
    <span>
      <Box component="span" sx={{ fontWeight: 600 }} children={TOOLTIP_BOLD} />
      {TOOLTIP}
    </span>
  );

  return (
    <Box sx={{ padding: theme.spacing(1.5, 0, 1.5) }}>
      <Box gap={1} display={'flex'} mb={theme.spacing(1)} alignItems={'center'}>
        <Typography tabIndex={0} variant="subtitle1" children={TITLE} />
        <Tooltip tabIndex={0} placement={'right'} title={tooltipContent}>
          <InfoOutlined sx={{ color: theme.palette.text.iconInfo, width: theme.spacing(2), height: theme.spacing(2) }} />
        </Tooltip>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <NRKeyValueDataDisplay keyWidth={KEY_WIDTH} dataKey={EXPLOITATION} value={<SSVCExploitationFormatter value={ssvc.exploitation} />} />
        <NRKeyValueDataDisplay keyWidth={KEY_WIDTH} dataKey={TECHNICAL_IMPACT} value={<SSVCTechImpactFormatter value={ssvc.technicalImpact} />} />
        <NRKeyValueDataDisplay keyWidth={KEY_WIDTH} dataKey={AUTOMATABLE} value={<SSVCAutomatableFormatter value={ssvc.automatable} />} />
        <NRKeyValueDataDisplay keyWidth={KEY_WIDTH} dataKey={SOURCE} value={ssvc.source} />
      </Box>
    </Box>
  );
};

export default NRSsvcDetails;
